module.exports = __webpack_public_path__ + "assets/asian_mobile-2f0c54.svg";